import { SERVER_API } from "../../Constant";
import axios from "axios";

export const FetchBikeThreewheelSalesReport_api = async (
  startDate: string,
  endDate: string,
  dealerId: string = "",
  vehicleType: string = "",
  paymentStatus: string = "",
) => {
  try {
    const response = await axios.get(
      `${SERVER_API}/Reports/fetch_bike_threewheel_sales_report.php`,
      {
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          startDate,
          endDate,
          dealerId,
          vehicleType,
          paymentStatus,
        },
      },
    );

    return response.data;
  } catch (error: any) {
    console.error("Fetch bike/threewheel sales report failed:", error);
    return { error: "Fetch bike/threewheel sales report failed" };
  }
};
